import { isValidElement } from 'react';

/**
 * Extracts the props type from a React component type.
 */

/**
 * Check if a node is a React element of a specific type.
 * @param node The node to check
 * @param type The type to check against
 * @returns True if the node is a React element of the specified type
 */
export function isElementOfType(node, type) {
  return /*#__PURE__*/isValidElement(node) && node.type === type;
}
export default isElementOfType;
//# sourceMappingURL=ElementUtils.js.map